/** @jsx jsx */
import { memo } from "react";
import { jsx } from "theme-ui";
import { Button } from "theme-ui";

var ButtonComponent = function ButtonComponent(_a) {
  var alignIcon = _a.alignIcon,
      block = _a.block,
      children = _a.children,
      className = _a.className,
      disabled = _a.disabled,
      icon = _a.icon,
      _onClick = _a.onClick,
      title = _a.title,
      _b = _a.variant,
      variant = _b === void 0 ? "primary" : _b;
  return jsx(Button, {
    className: className,
    variant: variant,
    sx: {
      flexDirection: alignIcon === "end" ? "row-reverse" : "row",
      width: block ? "100%" : "auto",
      justifyContent: "center"
    },
    onClick: function onClick(event) {
      event.currentTarget.blur();

      if (_onClick) {
        _onClick(event);
      }
    },
    title: title,
    disabled: disabled
  }, icon && jsx("span", {
    sx: {
      display: "flex",
      marginRight: alignIcon === "end" ? 0 : 1,
      marginLeft: alignIcon === "end" ? 1 : 0
    }
  }, icon), children);
};

export default memo(ButtonComponent);